<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h2 class="u">Добавить дом</h2>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'address-details', params: { address_id: $route.params.address_id } }">← Назад к Домам</router-link>
    </div>

    <building-add-form :address="+$route.params.address_id" @after="handleAfter" />

  </div>
</template>

<script>
import buildingAddForm from '@/components/forms/building/BuildingAddForm'

export default {
  name: 'building-add',
  components: { buildingAddForm },
  methods: {
    handleAfter (success) {
      if (success) {
        this.$router.push({ name: 'address-details', params: { address_id: this.$route.params.address_id } })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// BuildingAdd.vue?ba1fe902